<template>
  <div class="answer">
    <div class="top">
      <ul class="index">
        <li>{{busData.name}}</li>
        <li>倒计时：{{count}}</li>
      </ul>
    </div>
    <div v-show="showPass">
      <div class="pass"><span>恭喜考生{{busData.create_user_name}} ， 您获得的分数是:{{busData.score}}</span></div>
      <div class="passImg"><img src="/wall/pass.png" alt="" width="1440" height="448"></div>
      <div class="passButton"><el-button  @click="close()" type="primary" size="large">退出考试</el-button></div>
    </div>
    <div v-show="showDefeat">
      <div class="defeat"><span>考生{{busData.create_user_name}} ， 您获得的分数是:{{busData.score}}</span></div>
      <div class="defeatImg"><img src="/wall/defeat.png" alt="" width="1440" height="448"></div>
      <div class="defeatButton"><el-button  @click="close()" type="primary" size="large">退出考试</el-button></div>
    </div>
    <div v-show="showPaper">
      <div class="flexArea">
        <!--左边题目编号区-->
        <div class="left">
          <div class="l-bottom">
            <div class="item">
              <p class="total_score"><b>总分:{{ busData.total_score }}</b></p>
              <p class="pass_score"><b>及格:{{ busData.pass_score }}</b></p>
            </div>
          </div>
          <ul class="l-top">
            <li>
              <a href="javascript:"></a>
              <span>未答</span>
            </li>
            <li>
              <a href="javascript:"></a>
              <span>已答</span>
            </li>
          </ul>
          <div class="l-bottom">
            <div class="item">
              <div>
                <el-row>
                  <ul>
                    <li v-for="(item, index) in busData.itemList" :key="item.id">
                      <el-button v-if="!item.answer && index !== this.page" class="unAlready"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                      <el-button v-if="item.answer && index !== this.page" class="already" @click="goToProblem(index)">
                        {{ index + 1 }}
                      </el-button>
                      <el-button v-if="!item.answer && index === this.page" class="unAlready_now"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                      <el-button v-if="item.answer && index === this.page" class="already_now"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                    </li>
                  </ul>
                </el-row>

              </div>
            </div>
            <div class="final" type="text" @click="ahead">结束考试</div>
          </div>
        </div>
        <!--右边选择答题区-->
        <el-card class="right">
          <div v-for="(item,index) in busData.itemList" :key="item.id" class="content">
            <div v-if="index === page">
              <div class="single" v-if="item.question_type === 'single'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeSingle">单选题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-radio v-if="item.option_a" :label="'option_a'"><span
                      style="font-size: 18px">A. {{ item.option_a }}</span></el-radio>
                  <el-radio v-if="item.option_b" :label="'option_b'"><span
                      style="font-size: 18px">B. {{ item.option_b }}</span></el-radio>
                  <el-radio v-if="item.option_c" :label="'option_c'"><span
                      style="font-size: 18px">C. {{ item.option_c }}</span></el-radio>
                  <el-radio v-if="item.option_d" :label="'option_d'"><span
                      style="font-size: 18px">D. {{ item.option_d }}</span></el-radio>
                  <el-radio v-if="item.option_e" :label="'option_e'"><span
                      style="font-size: 18px">E. {{ item.option_e }}</span></el-radio>
                  <el-radio v-if="item.option_f" :label="'option_f'"><span
                      style="font-size: 18px">F. {{ item.option_f }}</span></el-radio>
                </el-radio-group>
              </div>
              <div class="fill" v-if="item.question_type === 'multiple'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeFill">多选题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-checkbox-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-checkbox v-if="item.option_a" :label="'option_a'"><span
                      style="font-size: 18px">A. {{ item.option_a }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_b" :label="'option_b'"><span
                      style="font-size: 18px">B. {{ item.option_b }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_c" :label="'option_c'"><span
                      style="font-size: 18px">C. {{ item.option_c }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_d" :label="'option_d'"><span
                      style="font-size: 18px">D. {{ item.option_d }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_e" :label="'option_e'"><span
                      style="font-size: 18px">E. {{ item.option_e }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_f" :label="'option_f'"><span
                      style="font-size: 18px">F. {{ item.option_f }}</span></el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="judge" v-if="item.question_type === 'judge'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeJudge">判断题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-radio :label="'correct'"><span style="font-size: 18px">是</span></el-radio>
                  <el-radio :label="'fault'"><span style="font-size: 18px">否</span></el-radio>
                </el-radio-group>
              </div>
              <div class="operation">
                <ul class="end">
                  <li @click="previous()" v-if="index !== 0" :class="index === 1 ? 'next' : 'before-next'">
                    <span>上一题</span><i class="iconfont icon-previous"></i></li>
                  <li @click="toNext()" v-if="index !== busData.itemList.length-1"
                      :class="index === 0 ? 'next' : 'before-next'">
                    <span>下一题</span><i class="iconfont icon-next"></i></li>
                </ul>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name:"ExamDetailUpdate",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      //倒计时
      count:'',
      //倒计时总秒数
      seconds:'',
      page: 0,
      index: 0, //全局index
      title: "请选择正确的选项",
      itemId: '',
      busData: {
        total_score: 0,
        time: '',
        name: '',
        pass_score:'',
        create_user_id:'',
        create_user_name:'',
        remark: '',
        score:'',
        id: '',
        itemList: [],
        //离开界面次数
        outNumber:'',
        //剩余考试时间
        seconds:'',
        status:"未完成"
      },
      //试卷信息
      item: {
        option_a:'',
        option_b:'',
        option_c:'',
        option_d:'',
        option_e:'',
        option_f:'',
        topic:''
      },
      //题号
      orderNumber: 0,
      //答案
      answer:'',
      //显示考试主要界面，默认显示
      showPaper: true,
      //展现考试通过页面,默认不显示
      showPass: false,
      //展现考试失败页面，默认不显示
      showDefeat:false,
      //显示考试界面顶端以及考试主要界面
      showExam:true,

    }
  },
  created() {
    this.checkUserId()
    this.putExamAnswerWithDetail()
  },
  methods: {
    //检查是否是本人试卷，若不是，则不允许继续考试
    async checkUserId(){
      this.currentUserId = await this.$http('ihtExamService.checkUserId');
      if (this.busData.create_user_id !== this.currentUserId){
        this.$message.error(`请注意！这不是您的答卷！`);
        return this.$fn.closeWindow();
      }
      this.monitor()
      this.mounted()
    },

    //下一题
    toNext() {
      // 索引+1；
      this.index ++;
      // page ++
      this.page ++;
    },

    //关闭界面
    close(){
      this.$fn.closeWindow();
      this.$fn.search();
    },

    previous() { //上一题
      this.index --;
      this.page --;
    },

    //跳转到指定题目
    goToProblem(index){
      this.index = index+1;
      this.page = index;
    },

    //显示倒计时
    countDown(){
      let h = parseInt(this.busData.seconds / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(this.busData.seconds / 60 % 60 );
      m = m < 10 ? "0" + m : m
      let s = parseInt(this.busData.seconds % 60 );
      s = s < 10 ? "0" + s : s
      this.count = h + '时' + m + '分' + s + '秒'
    },

    mounted() {
      // 启动计时器，每秒更新count值
      this.timer = setInterval(() => {
        if (this.busData.seconds > 0) {
          this.busData.seconds--;
          this.$http('ihtExamService.putSeconds', this.busData)
          this.countDown()
          if(this.busData.seconds === 600) {
            this.$message({
              showClose: true,
              type: 'error',
              message: '考生注意,考试时间还剩10分钟！！！'
            })}
          if(this.busData.seconds === 60) {
            this.$message({
              showClose: true,
              type: 'error',
              message: '考生注意,考试时间还剩1分钟！！！时间结束将自动交卷'
            })}
        } else {
          clearInterval(this.timer); // 倒计时结束，停止计时器
          this.over();
        }
      },1000);
    },

    //自动保存答案
    putAnswer(item){
      this.$http('ihtExamService.putAnswer', item)
    },

    //继续考试获取未完成试卷的信息
    async putExamAnswerWithDetail() {
      this.busData.id = this.parentData.id
      this.busData.name = this.parentData.name
      this.busData.time = this.parentData.time
      this.busData.remark = this.parentData.remark
      this.busData.total_score = this.parentData.total_score
      this.busData.pass_score = this.parentData.pass_score
      this.busData.create_user_id = this.parentData.create_user_id
      this.busData.seconds = await this.$http('ihtExamService.getSeconds',this.busData)
      this.busData.outNumber = await this.$http('ihtExamService.getOutNumber',this.busData)
      this.busData.create_user_name = await this.$http('ihtExamService.getExamPerson', this.busData)
      let params = {id: this.parentData.id}
      let templateData = await this.$http('ihtExamService.putExamAnswerWithDetail', params)
      this.busData.itemList = templateData.itemList || [];

    },

    //交卷计算分数，跳转界面
    async over(){
      this.busData.status = "已完成"
      this.busData.score = await this.$http('ihtExamService.getScoreSum', this.busData)
      this.$message.success("交卷成功");
      clearInterval(this.timer);
      if(this.busData.score >= this.busData.pass_score){
        this.showPaper = !this.showPaper;
        this.showPass = !this.showPass;//使false变为true显示
      } else {
        this.showPaper = !this.showPaper;
        this.showDefeat = !this.showDefeat //使false变为true显示
      }
    },

    //提前交卷弹框提醒
    ahead() {
      this.$confirm('您是否要提前结束考试', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.over();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    },

    //切出页面报提醒，防止作弊
    monitor(){
      document.body.onblur = () => {
        if(this.busData.status === "未完成"){
          this.busData.outNumber++;
          this.$http('ihtExamService.putOutNumber', this.busData)
          if (this.busData.outNumber === 1){
            alert(`请回到考试界面，你已离开${this.busData.outNumber}次，后续将不再弹出提醒，但会依然记录切出页面次数`)
          }
        }
      }
    },

  },

}
</script>

<style scoped lang="less">

.passButton {
  text-align: center;
}

.defeatButton {
  text-align: center;
}

.choice{
  margin-left: 30px;
}

.operation .end li {
  cursor: pointer;
  margin: 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 150, 220, 0.99);
  border-radius: 5px;
  width: 100px;
  height: 40px;
  color: #fff;
}
.operation {
  background-color: #fff;
  border-radius: 4px;
  padding: 30px;
  margin-right: 10px;
}
.operation .end {
  display: flex;
  align-items: center;
  color: rgb(39, 118, 223);
}

.content .topic {
  display: inline-flex;
  align-items:center;
}

.topic .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 35px;
}

.topic .question_typeSingle {
  padding: 0 5px 0 5px;
  color: #409eff;
  background-color: #d9ecff;
  font-size: 22px;
}

.topic .question_typeFill {
  padding: 0 5px 0 5px;
  color: #e6a23c;
  background-color: #faecd8;
  font-size: 22px;
}

.topic .question_typeJudge {
  padding: 0 5px 0 5px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 22px;
}

.topic .score{
  margin-left: 4px;
  font-size: 25px;
}

.content .el-radio-group {
  display: flex;
  flex-direction:column;
}

.content .el-radio-group el-radio {
  margin-left: 10px;
}

.content .el-checkbox-group{
  display: flex;
  flex-direction:column;
}

.el-radio-group {
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.tip p{
  margin: 5px;
  font-size: 20px;
  text-align: left;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}

.right .title p {
  display: flex;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  font-size: 20px;
}

.already{
  width: 35px;
  height: 35px;
  background-color:rgb(39, 118, 223);
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.already_now{
  width: 39px;
  height: 39px;
  background-color:rgb(39, 118, 223);
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  border-color: #fd0303;
  border-width: 3px;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.unAlready{
  width: 35px;
  height: 35px;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #394850;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.unAlready_now{
  width: 39px;
  height: 39px;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  border-color: #fd0303;
  border-width: 3px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.flexArea {
  display: flex;
}
.flexArea .right {
  flex: 1;
}

.right .title span {
  font-size: 20px;
}

.right .title {
  margin-right: 30px;
  padding-right: 40px;
  display: flex;
  margin-top: 10px;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
}

.pass {
  font-size: 30px;
  margin: 50px 0 0 10px;
  text-align: center;
}

.defeat {
  font-size: 30px;
  margin: 50px 0 0 10px;
  text-align: center;
}

.beginImg {
  margin: 30px;
  text-align: center;
}
.passImg {
  margin: 30px 0 0 0;
  text-align: center;
}

.defeatImg {
  margin: 30px 0 0 0;
  text-align: center;
}

.begin {
  text-align: center;
}
.begin-text{
  font-size: 30px;
}
.select {
  font-size: 27px;
}

.button {
  font-size: 27px;
}

.left {
  width: 260px;
  height: 100%;
  margin: 5px 10px 0 5px;
}

.left .l-top {
  display: flex;
  justify-content: space-around;
  padding: 10px 0 2px 2px;
  border: #fff;
  margin-top: 5px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.left .l-top li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.left .l-top li a {
  padding: 12px;
  background-color: #fff;
  border: 1px solid #394850;
  border-radius: 50%;
}

.left .l-top li:nth-child(2) a {
  background-color: rgb(39, 118, 223);
  padding: 13px;
  border: none;
  border-radius: 50%;
}

.answer .left .item {
  font-size: 16px;
}

.l-bottom .final {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  background-color: rgb(39, 118, 223);
  width: 200px;
  margin: 5px 0 10px 22px;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.l-bottom {
  padding: 10px 0 2px 2px;
  margin: 5px 5px 0 5px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.l-bottom .item {
  display: inline-block;
  background-color: #fff;
  flex-direction: column;
}

.l-bottom .item .total_score {
  margin-bottom: 8px;
  color: #4c8adc;
  margin-left: 10px;
  display: inline-block;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .pass_score {
  margin-bottom: 8px;
  color: #4c8adc;
  margin-left: 30px;
  display: inline-block;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .listing {
  margin-bottom: 8px;
  color: #000;
  margin-left: 10px;
  letter-spacing: 2px;
}

.l-bottom .item ul {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
}

.l-bottom .item li {
  margin-left: 8px;
  margin-bottom: 10px;
}

.l-bottom .item ul li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
}
.answer .top .index {
  display: flex;
  justify-content:space-between;
  color: #fff;
  padding: 20px;
  font-size: 22px;
}

.answer .top .index li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.answer .top {
  background-color: rgb(54, 106, 175);
}

.answer {
  padding-bottom: 30px;
}

</style>
